export const individualDocumentType = {
  'National ID': 'National ID',
  Passport: 'Passport',
  'Emirates ID': 'Emirates ID',
  'National Passport': 'National Passport',
  'Smart Card ID': 'Smart Card ID',
  'ID booklet': 'ID booklet',
  'Foreign Passport': 'Foreign Passport',
  PASSPORT: 'Passport',
  SSN: 'SSN',
  NATIONAL_ID: 'National ID',
  NATIONAL_PASSPORT: 'National Passport',
  EMIRATES_ID: 'Emirates ID',
  ID_BOOKLET: 'ID Booklet',
  SMART_CARD_ID: 'Smart Card ID',
  NATIONAL_ID_CARD: 'National ID Card',
  ZAF_SMART_CARD_ID: 'ZAF Smart Card ID',
  ZAF_ID_BOOKLET: 'ZAF ID Booklet',
  FOREIGN_PASSPORT: 'Foreign Passport',
  REFUGEE_ASYLUM_PERMIT: 'Refugee Asylum Permit',
  TAXPAYER_NUMBER: 'Taxpayer Number',
  BUSINESS_LICENCE: 'Business Licence',
  INCORPORATION_CERTIFICATE: 'Incorporation Certificate',
};

export const documentTypeParameters = {
  number: 'Business Registration Number',
  firstName: 'First Name',
  lastName: 'Last Name',
  dateOfIssue: 'Date of Issue',
  dateOfExpiry: 'Date of Expiry',
  countryOfIssue: 'Country of Issue',
  Seria: 'Tin Number',
};

export const documentTypePageNames = {
  first: 'First',
  front: 'Front',
  back: 'Back',
  portrait: 'Portrait',
  selfie: 'Selfie',
};
